import React, { useState, useCallback } from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import Loader from '../../../../widgets/plug/Loader/Loader';
import LazyLoad from 'react-lazy-load';
import css from './load-more.module.scss';

const LoadMore = ({ func }) => {
    const [loader, setLoader] = useState(false);

    const handler = useCallback(() => {
        setLoader(true);
        func();
    }, [func]);
    return (
        <div className={css.arrowMoreComponent} onClick={func}>
            <LazyLoad offset={500} onContentVisible={handler}>
                {loader ? (
                    <Loader compStyles={{ loader: css.loader }} />
                ) : (
                    svgSprite('angle-down', { width: '10px', height: '10px' })
                )}
            </LazyLoad>
        </div>
    );
};
export default LoadMore;
